import axios from 'axios'
import config from './config'

export default axios.create({
  baseURL: config.API_URL,
  headers: {
    'API-Key': '9159FB44-7F4D-4234-B04A-5C8969908F38',
  },
})
